import { API_BASE_URL as API_URL } from '../config';

export const candidateService = {
  async getCandidateGraph(limit = 50, offset = 0, filters = {}) {
    const token = sessionStorage.getItem('signalcue_token');
    if (!token) {
      throw new Error('Not authenticated');
    }

    // Build query parameters
    const params = new URLSearchParams();
    params.append('limit', limit.toString());
    params.append('offset', offset.toString());

    // Add filters if provided
    if (filters.minPriorityScore !== undefined) {
      params.append('min_priority_score', filters.minPriorityScore.toString());
    }
    if (filters.minFitScore !== undefined) {
      params.append('min_fit_score', filters.minFitScore.toString());
    }
    if (filters.minSignalScore !== undefined) {
      params.append('min_signal_score', filters.minSignalScore.toString());
    }
    if (filters.country) {
      params.append('country', filters.country);
    }
    if (filters.city) {
      params.append('city', filters.city);
    }
    if (filters.companyName) {
      params.append('company_name', filters.companyName);
    }
    if (filters.search) {
      params.append('search', filters.search);
    }
    if (filters.sector) {
      params.append('sector', filters.sector);
    }
    if (filters.role_family) {
      params.append('role_family', filters.role_family);
    }
    if (filters.geography) {
      params.append('geography', filters.geography);
    }
    if (filters.last_touch_days) {
      params.append('last_touch_days', filters.last_touch_days.toString());
    }

    try {
      const response = await fetch(`${API_URL}/api/candidates/graph?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        let errorMessage = 'Failed to fetch candidates';
        try {
          const error = await response.json();
          errorMessage = error.detail || errorMessage;
        } catch (e) {
          errorMessage = `API returned status ${response.status}`;
        }
        throw new Error(errorMessage);
      }

      return response.json();
    } catch (error) {
      if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        throw new Error(`Network error: Unable to connect to API at ${API_URL}. Please check your connection and try again.`);
      }
      throw error;
    }
  },

  async getCandidateProfile(candidateId) {
    const token = sessionStorage.getItem('signalcue_token');
    if (!token) {
      throw new Error('Not authenticated');
    }

    const response = await fetch(`${API_URL}/api/candidates/${candidateId}`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || 'Failed to fetch candidate profile');
    }

    return response.json();
  }
};
